import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AiService {
  private webhookUrl = 'https://n8n.safetrace.com.br/webhook/conectaGIS_IA';
  private storage: Storage;
  private token: any;
  private user: any;

  constructor(private http: HttpClient) {
    this.storage = window.sessionStorage;
    const item = this.storage.getItem('token');
    this.token = item ? JSON.parse(item) : {};
    const itemUser = this.storage.getItem('user');
    this.user = itemUser ? JSON.parse(itemUser) : {};
  }

  public sendMessageToAi(message: string, history: any[]): Observable<any> {
    const userContext = {
      username: this.user?.sub || this.user?.name || 'Usuário',
      customerId: this.user?.customerId || null,
      authorities: Array.isArray(this.user?.authorities) ? this.user.authorities : [],
      token: this.token,
    };

    const payload = {
      systemPrompt: this.getSystemPrompt(userContext),
      userMessage: message,
      chatHistory: history,
      userContext,
    };

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.post<any>(this.webhookUrl, payload, httpOptions).pipe(
      map((response) => {
        let parsedResponse: any = response;

        if (Array.isArray(response) && response.length > 0 && response[0]?.output) {
          let rawOutputString = String(response[0].output || '');
          rawOutputString = rawOutputString.replace(/[\u0000-\u001F\u007F-\u009F]/g, (char: string) => {
            return char === '\n' || char === '\r' || char === '\t' ? char : '';
          });

          try {
            parsedResponse = JSON.parse(rawOutputString);
          } catch (error) {
            parsedResponse = rawOutputString.trim().length > 0
              ? { responseType: 'text', text: rawOutputString }
              : { responseType: 'text', text: 'Desculpe, o assistente retornou um formato inválido.' };
            console.warn('Falha ao parsear resposta da IA:', error, rawOutputString);
          }
        }

        if (parsedResponse?.responseType === 'text' && parsedResponse?.text !== undefined) {
          return parsedResponse.text;
        }

        return parsedResponse;
      })
    );
  }

  private getSystemPrompt(context: any): string {
    const authorities = Array.isArray(context?.authorities) ? context.authorities.join(', ') : '';

    return `
Você é a Trace Fornecedores, um agente de atendimento de IA do aplicativo ConectaGis.
Seu objetivo é auxiliar o usuário (${context.username}, Customer ID: ${context.customerId}) na análise e gestão de fornecedores.

CONTEXTO DO USUÁRIO:
- Customer ID: ${context.customerId}
- Permissões: ${authorities}
- Você tem acesso às funcionalidades do aplicativo ligadas a protocolos e solicitações.

FUNCIONALIDADES:
1. Análise de fornecedores.
2. Consulta de protocolos.
3. Apoio à criação de solicitações.
4. Resumo de pendências.

FORMATO DE RESPOSTA OBRIGATÓRIO:
{
  "responseType": "text" | "action",
  "text": "Mensagem amigável para o usuário.",
  "action": {
    "type": "navigate" | "api_call",
    "details": {
      "route": "/safe-gis/protocolos" | "/safe-gis/solicitacoes/nova-solicitacao" | "/safe-gis/solicitacoes/solicitacoes-respondidas",
      "endpoint": "/protocol-service/list/filtered" | "/geo-monitoring/dto/list/with-response/filtered" | "/geo-monitoring/register/with-protocol",
      "method": "GET" | "POST",
      "payload": {}
    }
  }
}

REGRAS:
- Quando o usuário pedir apenas informação, prefira responseType "text".
- Quando pedir navegação para telas da aplicação, use action.type "navigate".
- Quando pedir listagem de protocolos, use action.type "api_call" com endpoint "/protocol-service/list/filtered".
- Quando pedir listagem de solicitações, use action.type "api_call" com endpoint "/geo-monitoring/dto/list/with-response/filtered".
- Quando todos os dados de uma nova solicitação forem fornecidos, use action.type "api_call" com endpoint "/geo-monitoring/register/with-protocol".
- Retorne JSON válido.
`;
  }
}
